import colors from 'vuetify/es5/util/colors'

export const graphRatingColours = [
  colors.grey.base,
  colors.red.base,
  colors.orange.base,
  colors.purple.lighten2,
  colors.lightBlue.base,
  colors.green.base
]

export const ratingLabels = ['N', 'V', 'L', 'P', 'G', 'H']
export const ratingLetter = ['N', 'V', 'L', 'P', 'G', 'H']

export const ratingMapping = {
  'N': 'NONE', 'V': 'VERY_LOW', 'L': 'LOW', 'P': 'PARTIAL', 'G': 'GOOD', 'H': 'HIGH'
}

export const ratingArray = ['NONE', 'VERY_LOW', 'LOW', 'PARTIAL', 'GOOD', 'HIGH']



// WEBPACK FOOTER //
// ./src/components/dashboard/ratings.js